export default "__VITE_ASSET__DLr0SIRx__"